<template>
  <v-container
    fluid
    class="fill-height"
  >
    <v-row class="justify-center align-center fill-height">
      <div class="text-center">
        <v-icon size="50">
          mdi-alert-circle
        </v-icon>
      </div>
    </v-row>
  </v-container>
</template>

<script setup lang="ts"></script>
